module.exports = __webpack_public_path__ + "assets/xiaoheiban.d6f923c9.svg";